// extracted by mini-css-extract-plugin
export default {"formField":"FormField_formField__ZA2Jo","combine":"FormField_combine__sr77R","body":"FormField_body__FAyS9","icon":"FormField_icon__wGTvF"};